// DS9.4.2, DS9.4.2M
import React from 'react';
import { useTranslation } from 'react-i18next';
import PollView from '../../../PollView';
import FeedCardLayout from '../_partials/FeedCardLayout';
import FeedCardTitle from '../_partials/FeedCardTitle';
import optionStyles from './PollOption.scss';
import s from './Poll.scss';
const PollFeedCardContents = ({ className, deviation, extraActions, withWatchOrSubscribeButton })=>{
    var _deviation_poll;
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(FeedCardLayout, {
        className: className,
        deviation: deviation,
        extraActions: extraActions,
        withWatchOrSubscribeButton: withWatchOrSubscribeButton,
        withCommentControl: true
    }, /*#__PURE__*/ React.createElement(FeedCardTitle, {
        className: s['title'],
        deviation: deviation,
        disableScrollRestoration: false
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['vote-count']
    }, t('pollView.votes', {
        count: (_deviation_poll = deviation.poll) === null || _deviation_poll === void 0 ? void 0 : _deviation_poll.votes
    })), /*#__PURE__*/ React.createElement(PollView, {
        deviation: deviation,
        hideQuestion: true,
        stylesheet: s,
        optionImageSize: 32,
        optionHoverImageSize: 192,
        optionStylesheet: optionStyles
    }));
};
PollFeedCardContents.displayName = 'PollFeedCardContents';
export default PollFeedCardContents;

//# sourceMappingURL=Poll.js.map